import React, { useState } from 'react';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Typography } from '@mui/material';

import { Button } from '@atoms';
import { successMessage, errorMessage } from '@services';
import { Axios } from '@helpers';
import { ConfirmModal } from '@organisms';
import dayjs from 'dayjs';

interface IProps {
  modelId: string;
  selectedIds: string[];
}

const ExportButton = (props: IProps) => {
  const { modelId, selectedIds } = props;

  const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);

  const onClose = () => setOpenConfirmModal(false);

  const handleExportSocialMediaLinks = async () => {
    try {
      const response = await Axios.get(`/admin/models/${modelId}/social-media-links`, {
        params: { ids: selectedIds, exportToCsv: true },
      });

      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `social media links ${dayjs().format('MM/DD/YYYY HH:mm')}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      successMessage('Social Media Links exported successfully');
      onClose();
    } catch (error) {
      errorMessage('Failed to export Social Media Links');
    }
  };

  const onClickExport = () => handleExportSocialMediaLinks();

  const onClickExportCSV = () => setOpenConfirmModal(true);

  return (
    <>
      <Button
        sx={{ paddingX: '20px' }}
        variant="outlined"
        color="black"
        startIcon={<FileDownloadOutlinedIcon />}
        onClick={onClickExportCSV}
      >
        Export CSV
      </Button>
      <ConfirmModal
        open={openConfirmModal}
        icon={null}
        onCancel={onClose}
        onSubmit={onClickExport}
        title={
          <Typography
            sx={{
              fontSize: '24px',
              lineHeight: '32px',
              color: '#464F6080',
              whiteSpace: 'normal',
              marginBottom: '-8px',
            }}
          >
            {selectedIds.length > 0 ? (
              `Do you want to export ${selectedIds.length} selected link(s)?`
            ) : (
              <>
                Do you want to export all links?
                <br />
                If don&#39;t, please select particular links to export
              </>
            )}
          </Typography>
        }
        submitText="Export"
        submitColor="primary"
        usingModalV2
      />
    </>
  );
};

export default ExportButton;
